import _classCallCheck from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defaultProps = {
  breakpointCols: undefined,
  // optional, number or object { default: number, [key: number]: number }
  className: undefined,
  // required, string
  columnClassName: undefined,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: undefined,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: undefined,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: undefined
};
var DEFAULT_COLUMNS = 2;
var Masonry = /*#__PURE__*/function (_React$Component) {
  _inherits(Masonry, _React$Component);
  var _super = _createSuper(Masonry);
  function Masonry(props) {
    var _this;
    _classCallCheck(this, Masonry);
    _this = _super.call(this, props); // Correct scope for when methods are accessed externally

    _this.reCalculateColumnCount = _this.reCalculateColumnCount.bind(_assertThisInitialized(_this));
    _this.reCalculateColumnCountDebounce = _this.reCalculateColumnCountDebounce.bind(_assertThisInitialized(_this)); // default state

    var columnCount;
    if (_this.props.breakpointCols && _this.props.breakpointCols.default) {
      columnCount = _this.props.breakpointCols.default;
    } else {
      columnCount = parseInt(_this.props.breakpointCols) || DEFAULT_COLUMNS;
    }
    _this.state = {
      columnCount: columnCount
    };
    return _this;
  }
  _createClass(Masonry, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.reCalculateColumnCount(); // window may not be available in some environments

      if (window) {
        window.addEventListener('resize', this.reCalculateColumnCountDebounce);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.reCalculateColumnCount();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window) {
        window.removeEventListener('resize', this.reCalculateColumnCountDebounce);
      }
    }
  }, {
    key: "reCalculateColumnCountDebounce",
    value: function reCalculateColumnCountDebounce() {
      var _this2 = this;
      if (!window || !window.requestAnimationFrame) {
        // IE10+
        this.reCalculateColumnCount();
        return;
      }
      if (window.cancelAnimationFrame) {
        // IE10+
        window.cancelAnimationFrame(this._lastRecalculateAnimationFrame);
      }
      this._lastRecalculateAnimationFrame = window.requestAnimationFrame(function () {
        _this2.reCalculateColumnCount();
      });
    }
  }, {
    key: "reCalculateColumnCount",
    value: function reCalculateColumnCount() {
      var windowWidth = window && window.innerWidth || Infinity;
      var breakpointColsObject = this.props.breakpointCols; // Allow passing a single number to `breakpointCols` instead of an object

      if (typeof breakpointColsObject !== 'object') {
        breakpointColsObject = {
          default: parseInt(breakpointColsObject) || DEFAULT_COLUMNS
        };
      }
      var matchedBreakpoint = Infinity;
      var columns = breakpointColsObject.default || DEFAULT_COLUMNS;
      for (var breakpoint in breakpointColsObject) {
        var optBreakpoint = parseInt(breakpoint);
        var isCurrentBreakpoint = optBreakpoint > 0 && windowWidth <= optBreakpoint;
        if (isCurrentBreakpoint && optBreakpoint < matchedBreakpoint) {
          matchedBreakpoint = optBreakpoint;
          columns = breakpointColsObject[breakpoint];
        }
      }
      columns = Math.max(1, parseInt(columns) || 1);
      if (this.state.columnCount !== columns) {
        this.setState({
          columnCount: columns
        });
      }
    }
  }, {
    key: "itemsInColumns",
    value: function itemsInColumns() {
      var currentColumnCount = this.state.columnCount;
      var itemsInColumns = new Array(currentColumnCount); // Force children to be handled as an array

      var items = React.Children.toArray(this.props.children);
      for (var i = 0; i < items.length; i++) {
        var columnIndex = i % currentColumnCount;
        if (!itemsInColumns[columnIndex]) {
          itemsInColumns[columnIndex] = [];
        }
        itemsInColumns[columnIndex].push(items[i]);
      }
      return itemsInColumns;
    }
  }, {
    key: "renderColumns",
    value: function renderColumns() {
      var _this$props2 = this.props,
        column = _this$props2.column,
        _this$props2$columnAt = _this$props2.columnAttrs,
        columnAttrs = _this$props2$columnAt === void 0 ? {} : _this$props2$columnAt,
        columnClassName = _this$props2.columnClassName;
      var childrenInColumns = this.itemsInColumns();
      var columnWidth = "".concat(100 / childrenInColumns.length, "%");
      var className = columnClassName;
      if (className && typeof className !== 'string') {
        this.logDeprecated('The property "columnClassName" requires a string'); // This is a deprecated default and will be removed soon.

        if (typeof className === 'undefined') {
          className = 'my-masonry-grid_column';
        }
      }
      var columnAttributes = _objectSpread(_objectSpread(_objectSpread({}, column), columnAttrs), {}, {
        style: _objectSpread(_objectSpread({}, columnAttrs.style), {}, {
          width: columnWidth
        }),
        className: className
      });
      return childrenInColumns.map(function (items, i) {
        return /*#__PURE__*/React.createElement("div", _extends({}, columnAttributes, {
          key: i
        }), items);
      });
    }
  }, {
    key: "logDeprecated",
    value: function logDeprecated(message) {
      console.error('[Masonry]', message);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        breakpointCols = _this$props.breakpointCols,
        columnClassName = _this$props.columnClassName,
        columnAttrs = _this$props.columnAttrs,
        column = _this$props.column,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);
      var classNameOutput = className;
      if (typeof className !== 'string') {
        this.logDeprecated('The property "className" requires a string'); // This is a deprecated default and will be removed soon.

        if (typeof className === 'undefined') {
          classNameOutput = 'my-masonry-grid';
        }
      }
      return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
        className: classNameOutput
      }), this.renderColumns());
    }
  }]);
  return Masonry;
}(React.Component);
Masonry.defaultProps = defaultProps;
export default Masonry;